import React, { useState } from "react";
import Icon from "./Icon";

function ExperienceEntry({ item, lead }) {
  const [open, setOpen] = useState(lead);
  return (
    <article
      className={"xp" + (lead ? " is-lead" : "") + (open ? " open" : "")}
      onClick={() => setOpen((o) => !o)}
    >
      <div className="xp-top">
        <div>
          <h3 className="xp-role">{item.role}</h3>
          <div className="xp-co">
            {item.company} <span className="note">· {item.note}</span>
          </div>
        </div>
        <span className="xp-dates">{item.dates}</span>
      </div>
      <p className="xp-summary">{item.summary}</p>
      <ul className="xp-bullets">
        {item.bullets.map((b, i) => <li key={i}>{b}</li>)}
      </ul>
      <div className="xp-stack">
        {item.stack.map((s) => <span className="chip" key={s}>{s}</span>)}
      </div>
      <div className="xp-expand">
        <Icon name="chevron-down" size={13} /> {open ? "less" : "details"}
      </div>
    </article>
  );
}

export default function Experience({ items }) {
  return (
    <div className="xp-list">
      {items.map((item, i) => (
        <ExperienceEntry key={item.company + item.role} item={item} lead={i === 0} />
      ))}
    </div>
  );
}
